// firestoreFunctions.js
import { db } from "../firebase";
import {
  collection,
  doc,
  addDoc,
  setDoc,
  updateDoc,
  getDocs,
  getDoc,
  orderBy,
  query,
  where,
  deleteDoc,
  serverTimestamp,
} from "firebase/firestore";

// Create a document with a generated ID
// export const createDocument = async (collectionName, data) => {
//   try {
//     const res = await addDoc(collection(db, collectionName), data);
//     console.log("Added document with ID: ", res.id);
//     return res.id;
//   } catch (error) {
//     console.error("Error creating document: ", error);
//     throw error;
//   }
// };
// Create a Product with a generated ID and createdAt timestamp
export const createProduct = async (collectionName, data) => {
  try {
    const newData = {
      ...data,
      count: 0,
      price: data.price ? Number(data.price) : undefined,
      limit: data.limit ? Number(data.limit) : undefined,
      createdAt: serverTimestamp(),
    };

    // console.log("newData", newData);
    const res = await addDoc(collection(db, collectionName), newData);
    // // console.log("Added document with ID: ", res.id);
    return res.id;
  } catch (error) {
    console.error("Error creating document: ", error);
    throw error;
  }
};

// Update a Product
export const updateProduct = async (collectionName, docId, data) => {
  const newData = {
    ...data,
    price: data.price ? Number(data.price) : 0,
    limit: data.limit ? Number(data.limit) : 0,
  };
  try {
    await updateDoc(doc(db, collectionName, docId), newData);
    console.log("Document updated:", docId);
  } catch (error) {
    console.error("Error updating document: ", error);
    throw error;
  }
};

// Create a document with a generated ID and createdAt timestamp
export const createDocument = async (collectionName, data) => {
  try {
    const newData = {
      ...data,
      count: 0,
      // price: data.price ? Number(data.price) : undefined,
      // limit: data.limit ? Number(data.limit) : undefined,
      createdAt: serverTimestamp(),
    };

    // console.log("newData", newData);
    const res = await addDoc(collection(db, collectionName), newData);
    // // console.log("Added document with ID: ", res.id);
    return res.id;
  } catch (error) {
    console.error("Error creating document: ", error);
    throw error;
  }
};

// Create or update a document (merge — safe even if the doc doesn't exist yet)
export const upsertDocument = async (collectionName, docId, data) => {
  try {
    await setDoc(doc(db, collectionName, docId), data, { merge: true });
  } catch (error) {
    console.error("Error upserting document: ", error);
    throw error;
  }
};

// Update a document
export const updateDocument = async (collectionName, docId, data) => {
  try {
    await updateDoc(doc(db, collectionName, docId), data);
    console.log("Document updated:", docId);
  } catch (error) {
    console.error("Error updating document: ", error);
    throw error;
  }
};

// Update a document in the 'product-list' collection by subtracting quantities
export const updateProductLimit = async (productId, quantity) => {
  try {
    const productRef = doc(db, "product-list", productId);

    // Get the current document data
    const productDoc = await getDoc(productRef);
    const currentData = productDoc.data();

    // Check if the 'limit' field exists and is a number
    if (typeof currentData.limit === "number") {
      // Subtract the quantity from the current 'limit'
      const newLimit = Math.max(currentData.limit - quantity, 0);

      // Update the 'limit' field in the document
      await updateDoc(productRef, { limit: newLimit });

      console.log("Product limit updated:", productId);
    } else {
      console.error("Invalid or missing limit field in the product document.");
    }
  } catch (error) {
    console.error("Error updating product limit:", error);
    throw error;
  }
};

// Get all documents from a collection
export const getAllDocuments = async (collectionName) => {
  try {
    const q = query(
      collection(db, collectionName),
      orderBy("createdAt", "desc")
    ); // Replace 'field' with your sorting field
    const snapshot = await getDocs(q);
    const documents = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    // console.log("Fetched all documents:", documents);
    return documents;
  } catch (error) {
    console.error("Error fetching documents: ", error);
    throw error;
  }
};

// Get a document by ID
export const getDocumentById = async (collectionName, docId) => {
  try {
    const docRef = doc(db, collectionName, docId);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) {
      console.log("No such document!");
      return null;
    } else {
      const documentData = { id: docSnap.id, ...docSnap.data() };
      // console.log("Document data:", documentData);
      return documentData;
    }
  } catch (error) {
    console.error("Error getting document by ID: ", error);
    // throw error;
  }
};

// Get all documents where the id field is "aw43y3bdyYJNgdd"
export const getAllDocumentsByID = async (collectionName, id) => {
  try {
    const q = query(collection(db, collectionName), where("userId", "==", id));
    const snapshot = await getDocs(q);

    const documents = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // console.log("Documents with id", id, ":", documents);
    return documents;
  } catch (error) {
    console.error("Error getting documents by id:", error);
    throw error;
  }
};

// Delete a document
export const deleteDocument = async (collectionName, docId) => {
  try {
    await deleteDoc(doc(db, collectionName, docId));
    console.log("Document deleted:", docId);
  } catch (error) {
    console.error("Error deleting document: ", error);
    throw error;
  }
};
